import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("ellipse", {
      cx: "12",
      cy: "8",
      rx: "8",
      ry: "3"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "12",
      cy: "16",
      rx: "8",
      ry: "3"
    }, null, -1)
  ]))]))
}
export default { render: render }